function editableClient(clientInfo) {
    if (clientInfo == null) {
        return null;
    }
    const client = Object.assign({}, clientInfo);
    delete client.pageHaveChange;
    return client;
}

function editableItem(item) {
    return {
        innerUUID: item.innerUUID,
        parentUUID: item.parentUUID,
        itemDescription: item.itemDescription,
        itemCode: item.itemCode,
        quantity: item.quantity,
        rate: item.rate,
        everyItemDiscountType: item.everyItemDiscountType,
        everyItemDiscount: item.everyItemDiscount,
        everyItemWithholdingStatus: item.everyItemWithholdingStatus,
        syncStatus: item.syncStatus,
        isShowInventory: item.isShowInventory,
        inventoryNumber: item.inventoryNumber,
        isShowCost: item.isShowCost,
        cost: item.cost,
        unit: item.unit,
        createdFromTime: item.createdFromTime,
        timeUUID: item.timeUUID,
        everyTaxInfoList: Array.isArray(item.everyTaxInfoList)
            ? item.everyTaxInfoList.map(tax => ({
                innerUUID: tax.innerUUID,
                newInnerUUID: tax.newInnerUUID,
                chooseRate: tax.chooseRate,
                taxType: tax.taxType
            }))
            : []
    };
}

function editableFile(file) {
    return {
        innerUUID: file.innerUUID,
        attachmentName: file.attachmentName,
        attachmentDesciption: file.attachmentDesciption,
        syncStatus: file.syncStatus
    };
}

export function serializeDocumentEditorState(editor) {
    return JSON.stringify({
        clientInfo: editableClient(editor.clientInfo),
        createClientDivStatus: editor.createClientDivStatus,
        itemList: Array.isArray(editor.itemList) ? editor.itemList.map(editableItem) : [],
        fileList: Array.isArray(editor.fileList) ? editor.fileList.map(editableFile) : [],
        paymentHistory: editor.paymentHistory,
        comment: editor.comment,
        estimateStatus: editor.estimateStatus,
        bigDiscountType: editor.bigDiscountType,
        bigDiscount: editor.bigDiscount,
        invoiceStartDate: editor.invoiceStartDate,
        dueDate: editor.dueDate,
        termDay: editor.termDay,
        shipping: editor.shipping,
        jobDetailsListList: editor.jobDetailsListList,
        numPrefix: editor.numPrefix,
        invoiceMaxNumber: editor.invoiceMaxNumber,
        saveNewItemToItem: editor.saveNewItemToItem,
        sendEmail: editor.sendEmail,
        emailMessage: editor.userSetting == null ? undefined : editor.userSetting.emailMessage
    });
}

